import React, {useEffect, useMemo, useState} from 'react';
import {Bubble, Button} from "tea-component";
import {shallowEqual, useSelector} from 'umi';
import {format} from 'sql-formatter';
import RightSqlTable from '../RightSqlTable';
import Loading from '@/pages/dashboard/components/Loadings';
import LoadingFailed from '@/pages/dashboard/components/LoadingFailed';
import {useDblIntl} from '@/pages/datalab/utils/utils';
import { checkSqlAndOperation } from '@dbl/services/dataSource';
import SvgIcon from '@/pages/home/components/SvgIcon';
import operationBtn from '@/pages/datalab/assets/svg/operationBtn.svg';

import './index.scss';
import {LazyEditor} from '@/pages/datalab/components/AceEditor/LazyEditor';
// import { useTokenFailureSetSessionCache } from '../../../..';

// const AceEditor = lazy(() => {
//   return import('react-ace')
// });
const RightSqlEdit = (props: any) => {
  const { leftParams, getRightParams, editConfig, replaceKeywordExtension, isSpliceValue } = props;
  const { isFromEdit, editInitData } = editConfig || {};
  const { databaseValue, schemaValue, firstSeleted } = leftParams || {};
  const gameCode = useSelector((state: any) => state?.datalab?.gameCode, shallowEqual);
  const { formatMessage, commonFormatMessage } = useDblIntl('multi');
  const [sqlValue, setSqlValue] = useState(isFromEdit ? editInitData?.sql : '');
  const [error, setError] = useState('');
  const [sqlCheckError, setSqlCheckError] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [showBotomResult, setShowBotomResult] = useState(false);
  const [tableData, setTableData] = useState({});
  const [loading, setLoading] = useState(true);
  // const { takeEffect, userFailureValue } = useTokenFailureSetSessionCache(
  //   useMemo(
  //     () => ({ sqlValue, error, sqlCheckError,tableData }),
  //     [error, sqlCheckError, sqlValue, tableData],
  //   ),
  // );
  useEffect(() => {
    const { sqlValue, databaseValue, schemaValue } = editInitData || {};
    // || takeEffect
    if (!isFromEdit || !sqlValue || !databaseValue || !schemaValue ) return;
    setSqlValue(editInitData?.sqlValue);
    getRightParams({
      sqlValue: editInitData?.sqlValue,
      loading: false,
      isNodata: false
    });
    checkOrRunSqlFunc({
      game_code: gameCode,
      operate: 'run',
      sql: editInitData?.sqlValue,
      database_uuid: databaseValue,
      schema: schemaValue,
    }, 'run',true);
  }, [JSON.stringify(editInitData)]);

  // useEffect(() => {
  //   if (takeEffect) {
  //     const { sqlValue, error, sqlCheckError, tableData } =
  //       userFailureValue || {};
  //     setSqlValue(sqlValue);
  //     setError(error);
  //     setSqlCheckError(sqlCheckError);
  //     setTableData(tableData);
  //   }
  // }, [takeEffect, userFailureValue]);

  const checkOrRunSqlFunc = (params: any, requestType: string,isEditInit?:boolean) => {
    const isCheck = requestType === 'check';// || requestType === 'format'
    const isFromFormat = requestType === 'format';
    // const isSearch = requestType === 'search';
    const isRun = requestType === 'run';
    // const isShowTable = isSearch || !isCheck;
    const sqlSearchValue = isEditInit ? editInitData?.sqlValue : `SELECT * FROM ${firstSeleted?.table_name}`;
    // 快速查询时将快速查询的sql填入编辑器
    // if (isSearch) {
    //   setSqlValue(sqlSearchValue);
    //   getRightParams({
    //     sqlValue: sqlSearchValue,
    //     loading: true,
    //     isNodata: false
    //   });
    // }

    setShowResult(true);
    setShowBotomResult(true);
    setShowTable(false);
    setShowMsg(true);
    setLoading(true);
    setError('');
    checkSqlAndOperation(params).then((res: any) => {
      setSqlCheckError('');
      setError('');
      if (isFromFormat) {
        let formatSql: string;
        try {
          formatSql = format(sqlValue, { language: 'mysql' });
        } catch (e) {
          console.error("SQL格式化失败", {e, sqlValue});
          formatSql = sqlValue;
        }
        setSqlValue(formatSql);
      }
      if (!isCheck) {
        setTableData(res);
        setShowTable(true);
      }
      if (isRun) {
        getRightParams({
          sqlValue: isEditInit ? sqlSearchValue : sqlValue,
          loading: false,
          // 不过有无数据，都需放开提交按钮
          isNodata: false
        });
      }
      setLoading(false);
    }).catch((e) => {
      // 和后端核对后code 为10000\10002时为sql校验出错
      if (e?.code === 10000 || e?.code === 10002) {
        setSqlCheckError(e?.data || commonFormatMessage('load_fail'));
      }
      setError(e?.data || commonFormatMessage('load_fail'));
      setShowTable(false);
      setLoading(false);
      setTableData({});
      getRightParams({
        sqlValue: isEditInit ? sqlSearchValue : sqlValue,
        loading: false,
        isNodata: true,
      });
    });
  };

  const setSqlValueFunc = (val: string) => {
    setSqlValue(val);
    getRightParams({
      sqlValue: val,
      loading: true,
      isNodata: false
    });
  };

  const sqlOnChange = (val: string) => {
    setShowBotomResult(false);
    setSqlValueFunc(val);
  };

  const onStartOperation = () => {
    if (!sqlValue) return;

    getRightParams({
      sqlValue,
      loading: true,
      isNodata: false,
    });
    // setShowResult(true);
    // setShowBotomResult(true);
    // setShowTable(false);
    // setShowMsg(true);
    // setLoading(true);
    // setError('');
    checkOrRunSqlFunc({
      game_code: gameCode,
      operate: 'run',
      sql: sqlValue,
      database_uuid: databaseValue,
      schema: schemaValue,
    }, 'run');
    
    // checkSqlAndOperation(params).then((res: any) => {
    //   setSqlCheckError('');
    //
    // }).catch((e) => {
    //   // 和后端核对后code 为10000时为sql校验出错
    //   if (e?.code === 10000 || e?.code === 10002) {
    //     setSqlCheckError(e?.data || '');
    //   }
    //   setError(e?.data || '');
    //   setLoading(false);
    //   getRightParams({
    //     sqlValue,
    //     loading: false,
    //     isNodata: true,
    //   });
    // });

  };

  // const onSearch = () => {
  //   const sqlStr = `SELECT * FROM ${firstSeleted?.table_name}`
  //   checkOrRunSqlFunc({
  //     game_code: gameCode,
  //     operate: 'run',
  //     sql: sqlStr,
  //     database_uuid: databaseValue,
  //     schema: schemaValue,
  //   }, 'search')
  // }

  const onSqlFormat = () => {
    if (!sqlValue) return;
    let formatSql: string;
    try {
      formatSql = format(sqlValue, { language: 'mysql' });
    } catch (e) {
      console.error("SQL格式化失败", {e, sqlValue});
      formatSql = sqlValue;
    }
    setSqlValueFunc(formatSql);
  };

  const onCheck = () => {
    if (!sqlValue) return;
    checkOrRunSqlFunc({
      game_code: gameCode,
      operate: 'check',
      sql: sqlValue,
      database_uuid: databaseValue,
      schema: schemaValue,
    }, 'check');
  };

  const onClear = () => {
    setShowResult(false);
    setSqlValueFunc('');
  };

  const operationNextBtnDisabled = useMemo(() => sqlValue === '' || databaseValue === '' || schemaValue === '', [sqlValue, databaseValue, schemaValue]);

  // const searchBtnDisabled = useMemo(() => {
  //   return !firstSeleted?.table_name || databaseValue === '' || schemaValue === ''
  // }, [firstSeleted, databaseValue, schemaValue])

  return (
    <div className='dbl-drag-add-sourse-right'>
      <div className='dbl-drag-add-sourse-right-btn-box'>
        <Button
          className='dbl-drag-add-sourse-right-btn-box-btn dbl-drag-add-sourse-right-btn-box-btn-run'
          type="primary"
          onClick={onStartOperation}
          disabled={operationNextBtnDisabled}
        >
          <img src={operationBtn} alt="" />
          {formatMessage({ id: 'dbl_sql_add_run' })}
        </Button>
        {/* <Button*/}
        {/*  className='dbl-drag-add-sourse-right-btn-box-btn dbl-drag-add-sourse-right-btn-box-btn-search'*/}
        {/*  type="primary"*/}
        {/*  onClick={onSearch}*/}
        {/*  disabled={searchBtnDisabled}*/}
        {/* >*/}
        {/*  {formatMessage({ id: 'dbl_sql_add_preview' })}*/}
        {/* </Button>*/}

        <div className='dbl-add-sourse-edit-operation'>
          <Bubble
            arrowPointAtCenter
            content={formatMessage({ id: 'dbl_sql_add_format' })}
            dark={true}
          >
            <span>
              <SvgIcon type="format" className='dbl-add-sourse-edit-operation-icon' onClick={onSqlFormat} />
            </span>
          </Bubble>

          <Bubble
            arrowPointAtCenter
            content={formatMessage({ id: 'dbl_sql_add_grammar_detection' })}
            dark={true}
          >
            <span>
              <SvgIcon type="search-a" className='dbl-add-sourse-edit-operation-icon' onClick={onCheck} />
            </span>
          </Bubble>
          <Bubble
            arrowPointAtCenter
            content={formatMessage({ id: 'dbl_sql_add_clear' })}
            dark={true}
          >
            <span>
              <SvgIcon type="datalab-clear" className='dbl-add-sourse-edit-operation-icon' onClick={onClear} />
            </span>
          </Bubble>

        </div>
      </div>

      {/* <Suspense fallback={<><Loading /></>}> */}
      <LazyEditor
        className="dbl-add-source-sql-edit"
        name='add-source-sql-edit'
        height={((showResult && showTable && showBotomResult) || (showResult && showMsg && showBotomResult)) ? '228px' : '546px'}
        // width='452px'
        aria-label="query editor input"
        mode="mysql"
        theme="tomorrow"
        fontSize={14}
        // width="100%"
        showPrintMargin={false}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
        }}
        showLineNumbers={true}
        showGutter={true}
        value={sqlValue}
        replaceKeywordExtension={replaceKeywordExtension}
        isSpliceValue={isSpliceValue}
        onChange={sqlOnChange}
        placeholder={formatMessage({ id: 'dbl_sql_edit_placeholder' })}
      />
      {/* </Suspense> */}
      {
        (showResult) && <div className={'dbl-right-sql-edit-result'}>
          <div className='dbl-right-sql-edit-result-title' onClick={() => {
            setShowBotomResult(!showBotomResult);
          }}>
            <SvgIcon type={showBotomResult ? "point-down":"arrow-right" } className='dbl-right-sql-edit-result-title-icon' />
            <div className='dbl-right-sql-edit-result-title-text'>{formatMessage({ id: 'dbl_sql_add_result' })}</div>
          </div>

          { showBotomResult &&
            <>
              {
                showTable && <RightSqlTable tableData={tableData} loading={loading} error={error} />
              }
              <>
                {!showTable && showMsg && (
                  (loading) ? <div className='dbl-right-sql-edit-loading'><Loading /></div> : <div>
                    {
                      sqlCheckError ? <div className='dbl-right-sql-edit-error'>
                        <div className='dbl-right-sql-edit-error-title'>{formatMessage({ id: 'dbl_sql_add_failed_msg' })}</div>
                        <div className='dbl-right-sql-edit-error-msg'>{sqlCheckError}</div>
                      </div> : (error ? <LoadingFailed /> : <div className='dbl-right-sql-edit-success'>
                        <div className='dbl-right-sql-edit-success-title'>{formatMessage({ id: 'dbl_sql_add_success_msg' })}</div>
                        <div className='dbl-right-sql-edit-success-msg'> {formatMessage({ id: 'dbl_multi_filed_sql_success' })}</div>
                      </div>)
                    }
                  </div>)
                }
              </>
            </>
          }

        </div>
      }
    </div>
  );
};

export default RightSqlEdit;
